import StaticPageLayout from "../components/layout/StaticPageLayout";

const h2 = "text-[1.1rem] font-semibold text-[var(--pc-ink)] tracking-[-0.02em] mt-10 mb-3 first:mt-0";

export default function PolitiqueConfidentialitePage() {
  return (
    <StaticPageLayout
      pageTitle="Politique de confidentialité — Prévention Conseil"
      h1="Politique de confidentialité"
    >
      <h2 className={h2}>Responsable du traitement</h2>
      <p>
        ECORENO FRANCE — 122 rue du Commandant Rolland, 13008 Marseille
        <br />
        <a href="mailto:contact@preventionconseil.fr" className="font-medium text-[var(--pc-blue)] hover:underline">
          contact@preventionconseil.fr
        </a>{" "}
        —{" "}
        <a href="tel:+33972124684" className="font-mono-num font-medium text-[var(--pc-blue)] hover:underline">
          09 72 12 46 84
        </a>
      </p>

      <h2 className={h2}>Données collectées</h2>
      <p>
        Nom, prénom, numéro de téléphone, adresse email, et informations relatives à l'entreprise (effectif, secteur
        d'activité).
      </p>

      <h2 className={h2}>Finalité</h2>
      <p>
        Ces données sont utilisées exclusivement pour vérifier l'éligibilité de l'entreprise et prendre contact avec le
        dirigeant dans le cadre d'une démarche de conseil.
      </p>

      <h2 className={h2}>Conservation</h2>
      <p>Les données sont conservées pendant une durée maximale de 3 ans à compter du dernier contact.</p>

      <h2 className={h2}>Partage des données</h2>
      <p>
        Aucune donnée n'est vendue ni transmise à des tiers à des fins commerciales. Une transmission peut avoir lieu
        uniquement si la loi l'exige ou avec votre accord explicite (prestataires techniques strictement nécessaires à
        l'hébergement ou au fonctionnement du service).
      </p>

      <h2 className={h2}>Vos droits (RGPD)</h2>
      <p>
        Droit d'accès, de rectification, de suppression et d'opposition. Contact :{" "}
        <a href="mailto:contact@preventionconseil.fr" className="font-medium text-[var(--pc-blue)] hover:underline">
          contact@preventionconseil.fr
        </a>
      </p>
    </StaticPageLayout>
  );
}
